import { LeftSideBar, Navigation } from 'components/core-v2'

import { PortfolioAdminWithState } from './pages/portfolios-with-state'
import { TopBarElement } from './top-bar-element'

export const PortfolioAdmin = () => (
  <LeftSideBar
    leftElement={<Navigation />}
    mainElement={<PortfolioAdminWithState />}
    topBarElement={<TopBarElement />}
  />
)
